import React from 'react';
import UserProfile from '../components/user/UserProfile';

const ProfilePage = () => {
  return (
    <div>
      <UserProfile />
    </div>
  );
};

export default ProfilePage; 